import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "supplier-questions-page";

const keys = addTranslations(RESOURCE_NAME, {
    title: {
        en: "Supplier Questions",
        fr: "Questions pour les fournisseurs",
    },
    subTitle: {
        en: "Manage your questions and send them to suppliers",
        fr: "Gérez vos questions et envoyez-les aux fournisseurs",
    },
});

export function useSupplierQuestionsPageTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
